import { jsx as _jsx } from "react/jsx-runtime";
import './style.scss';
import { useState } from 'react';
import AccordionItem from '../AccordionItem';
export const Accordion = ({ items, firstDefaultOpened }) => {
    const [openedItemIndex, setOpenedItemIndex] = useState(firstDefaultOpened ? 0 : null);
    const handleToggle = (index) => {
        setOpenedItemIndex((prev) => (prev === index ? null : index));
    };
    const handleKeyDown = (e, index) => {
        switch (e.key) {
            case 'Enter':
            case ' ':
                e.preventDefault();
                handleToggle(index);
                break;
        }
    };
    return (_jsx("div", { className: "accordion", children: items.map((item, index) => (_jsx(AccordionItem, { title: item.title, content: item.content, isOpened: openedItemIndex === index, onClick: () => handleToggle(index), onKeyDown: (e) => handleKeyDown(e, index) }, item.id))) }));
};
export default Accordion;
